/**
 * Generate the initials from a full name, or take x arguments and return their first letter
 * This supports multi-byte characters
 * @param {array[string]} nameParts
 */
export default function getNameInitials(...nameParts) {
    if (nameParts.length === 1) {
        nameParts = nameParts[0].trim().split(' ')
    }

    try {
        const initials = []

        nameParts.forEach(part => {
            // Remove strange characters like ( / + = from the received names.
            const formattedPart = part.replace(/([^A-Za-zÀ-ÖØ-öø-ÿ])/gi, '')
            // Remove empty parts as they will return undefined when applying fromCodePoint.
            if (formattedPart === '') {
                return
            }
            initials.push(String.fromCodePoint(formattedPart.codePointAt(0)))
        })

        return initials.slice(0, 2).join('')
    } catch (error) {
        console.error(error)
        return ''
    }
}
